import type { LabelValue } from "~types/labelValue";
import type { EntityGroupScope, PermissionScopeResources } from "~types/permissionScope";
import type { EntitySelectOption } from "../types";

const transformEntityGroupScopeTree = (
  data: EntityGroupScope[],
  resources: PermissionScopeResources,
): { entityGroups: LabelValue[]; entities: EntitySelectOption[] } => {
  const { entities: entitiesData = {}, entityGroups: entityGroupsData = {} } = resources;

  const transformedData = data.reduce<{ entityGroups: LabelValue[]; entities: EntitySelectOption[] }>(
    (accumulator, currentValue) => {
      if (currentValue.entityGroupId && currentValue.entityGroupId in entityGroupsData) {
        const entityGroup = entityGroupsData[currentValue.entityGroupId];
        accumulator.entityGroups.push({ value: entityGroup.entityGroupId, label: entityGroup.nameFullLocal });
      }

      currentValue.entityIds.forEach((entityId) => {
        if (entityId in entitiesData) {
          const entity = entitiesData[entityId];
          accumulator.entities.push({
            value: entity.entityId,
            label: entity.nameFullLocal,
            ageGroup: entity.ageGroup,
            status: entity.status,
            standard: entity.standard,
            discipline: entity.discipline,
            gender: entity.gender,
          });
        }
      });
      return accumulator;
    },
    { entities: [], entityGroups: [] },
  );

  transformedData.entities = transformedData.entities.sort((a, b) => a.label.localeCompare(b.label));
  transformedData.entityGroups = transformedData.entityGroups.sort((a, b) => a.label.localeCompare(b.label));

  return transformedData;
};

export default transformEntityGroupScopeTree;
